import { Table, TableProps } from './Table';

const MAX_PAGE_SIZE = 999999;

export const InfiniteScrollTable = <T extends object = Record<string, unknown>>(
  props: TableProps<T> & {
    handleScroll: (e: React.UIEvent<HTMLDivElement>) => void;
  }
) => {
  const { data, noData, columns, handleScroll } = props;

  return (
    <div onScroll={handleScroll} className='mt-2' style={{ height: '380px', overflowY: 'scroll' }}>
      <Table pageSize={MAX_PAGE_SIZE} columns={columns} data={data} noData={noData} />
    </div>
  );
};
